<template>
	<div id="rename-custom-block-modal" class="modal-new hidden">
		<svg class="btn-close-modal" xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24">
			<path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
			<path d="M0 0h24v24H0z" fill="none" />
		</svg>
		<span class="title">Rename Custom Layout</span>

		<input type="text" name="custom-block-name" placeholder="Name" v-model="name" />
		<div class="buttons-continer">
			<button type="button" class="modal-btn --primary" @click="renameLayout">Save</button>
			<button type="button" class="modal-btn --cancel" data-modal-action="close-modal">Cancel</button>
		</div>
	</div>
</template>

<script>
import { mapGetters } from "vuex";
import FilenameMixin from "@/mixins/Filename";

export default {
	mixins: [FilenameMixin],

	data() {
		return {
			newName: "",
		};
	},

	computed: {
		...mapGetters("UserFiles", ["selectedLayout"]),
		name: {
			get() {
				return this.stripTimestampAndExtension(this.selectedLayout.name);
			},
			set(newName) {
				this.newName = newName;
			},
		},
	},

	methods: {
		renameLayout() {
			window.UI.hideModal();

			if (this.newName == "") this.newName = `Layout.${Date.now()}.json`;
			else {
				this.newName = `${this.newName}.${Date.now()}.json`;
			}

			this.$store
				.dispatch("UserFiles/renameLayout", this.newName)
				.then(() => {
					window.UI.message.activate(`Custom Layout Renamed Successfully`);
					this.$store.dispatch("UserFiles/fetchLayouts");
				})
				.catch(() => {
					window.UI.message.activate(`Renaming Custom Layout Failed`);
				});
		},
	},
};
</script>

<style></style>
